export const articles = [
  {
    slug: 'xin-shou-ma-ma-jiao-lv-zhi-nan',
    title: '新手妈妈的焦虑自救指南：从慌乱到从容的 6 个心理练习',
    excerpt: '成为妈妈的第一年，焦虑如影随形。本文为你梳理 6 个简单有效的心理调适练习，帮助你在角色转变中找到内心的平静与力量。',
    category: 'xin-li-tiao-shi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20mother%20sitting%20peacefully%20by%20a%20sunlit%20window%20holding%20a%20warm%20cup%20of%20tea%2C%20soft%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20calm%20and%20serene%20atmosphere%2C%20cozy%20home%20interior%20with%20plants%2C%20gentle%20pastel%20tones%2C%20editorial%20lifestyle%20photography%20with%20soft%20shadows%20and%20warm%20neutral%20background&width=800&height=500&seq=article-cover-anxiety&orientation=landscape',
    readTime: 8,
    publishedAt: '2026-07-28',
    tags: ['新手妈妈', '焦虑管理', '心理调适'],
  },
  {
    slug: 'chan-hou-yi-yue-zi-ke-xue-fang-an',
    title: '科学坐月子全攻略：产后 42 天身体恢复时间表',
    excerpt: '告别传统坐月子的误区，用现代医学视角重新规划产后恢复。从产后第一天到第 42 天的详细恢复方案，帮你科学度过月子期。',
    category: 'chan-hou-hui-fu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20peaceful%20postpartum%20recovery%20room%20with%20soft%20natural%20lighting%2C%20a%20comfortable%20bed%20with%20warm%20textiles%2C%20a%20small%20bassinet%20nearby%2C%20nourishing%20food%20on%20a%20wooden%20tray%2C%20gentle%20cream%20and%20blush%20tones%2C%20calm%20and%20healing%20atmosphere%2C%20editorial%20interior%20photography&width=800&height=500&seq=article-cover-postpartum&orientation=landscape',
    readTime: 12,
    publishedAt: '2026-07-25',
    tags: ['产后恢复', '科学坐月子', '身体调理'],
  },
  {
    slug: 'yu-er-zhong-de-fu-qi-guan-xi',
    title: '有了孩子之后，如何不让夫妻关系降温？',
    excerpt: '宝宝出生后，很多夫妻发现彼此的关系在不知不觉中疏远了。本文分享 5 个实用策略，帮助你们在育儿的同时守护爱情的温度。',
    category: 'qin-zi-guan-xi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20couple%20sitting%20together%20on%20a%20cozy%20sofa%20with%20their%20sleeping%20baby%20nearby%2C%20warm%20evening%20lighting%2C%20tender%20moment%2C%20soft%20throw%20blankets%2C%20intimate%20home%20setting%2C%20gentle%20warm%20tones%2C%20editorial%20lifestyle%20photography%20with%20soft%20focus&width=800&height=500&seq=article-cover-couple&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-22',
    tags: ['夫妻关系', '家庭关系', '亲子关系'],
  },
  {
    slug: 'you-er-shi-wu-tian-jia-gong-lve',
    title: '宝宝辅食添加全攻略：6-12 个月分月龄喂养方案',
    excerpt: '从第一口米粉到自主进食，手把手教你科学添加辅食。包含各月龄的食材清单、制作方法和注意事项，让宝宝吃得营养又开心。',
    category: 'ke-xue-yu-er',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20wooden%20high%20chair%20with%20colorful%20healthy%20baby%20food%20arranged%20neatly%20on%20a%20tray%2C%20natural%20sunlight%20from%20a%20nearby%20window%2C%20fresh%20fruits%20and%20vegetables%20in%20the%20background%2C%20warm%20kitchen%20setting%2C%20soft%20pastel%20colors%2C%20clean%20minimalist%20food%20photography&width=800&height=500&seq=article-cover-babyfood&orientation=landscape',
    readTime: 10,
    publishedAt: '2026-07-20',
    tags: ['辅食添加', '科学喂养', '宝宝营养'],
  },
  {
    slug: 'ma-ma-de-du-shu-bi-ji',
    title: '当了妈妈也要读书：5 本改变我育儿观的好书推荐',
    excerpt: '在带娃的碎片时间里，读一本好书是最好的自我投资。这 5 本书帮我重新理解了孩子、自己与家庭的关系。',
    category: 'zi-wo-ti-sheng',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20nook%20with%20a%20stack%20of%20beautiful%20books%20and%20a%20warm%20throw%20blanket%2C%20soft%20afternoon%20sunlight%20falling%20on%20the%20pages%2C%20a%20cup%20of%20tea%20nearby%2C%20houseplants%20in%20the%20background%2C%20peaceful%20vibe%2C%20warm%20cream%20and%20terracotta%20tones%2C%20editorial%20interior%20photography&width=800&height=500&seq=article-cover-reading&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-07-18',
    tags: ['妈妈成长', '阅读推荐', '自我提升'],
  },
  {
    slug: 'chan-hou-qing-xu-di-gu-zen-me-ban',
    title: '产后情绪低落不是矫情：识别与应对产后抑郁的完整指南',
    excerpt: '大约 15% 的新妈妈会经历产后抑郁，但很多人不敢开口求助。了解产后抑郁的早期信号和科学的应对方法，你并不孤单。',
    category: 'xin-li-tiao-shi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20mother%20resting%20her%20head%20on%20a%20soft%20pillow%20looking%20thoughtful%2C%20gentle%20sunlight%20through%20a%20window%20creating%20warm%20shadows%2C%20a%20journal%20and%20pen%20on%20the%20bedside%20table%2C%20hope%20and%20healing%20atmosphere%2C%20soft%20warm%20neutral%20tones%2C%20sensitive%20editorial%20portrait%20photography&width=800&height=500&seq=article-cover-ppd&orientation=landscape',
    readTime: 9,
    publishedAt: '2026-07-15',
    tags: ['产后抑郁', '心理健康', '情绪管理'],
  },
  {
    slug: 'hai-zi-shui-mian-xun-lian-fang-fa',
    title: '宝宝睡眠训练方法对比：温和派 vs 科学派，哪种适合你家？',
    excerpt: '宝宝睡不好，全家人跟着遭罪。对比市面上主流的 4 种睡眠训练方法，找到最适合你和宝宝的那一种。',
    category: 'ke-xue-yu-er',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20peaceful%20baby%20nursery%20with%20a%20white%20crib%20and%20soft%20bedding%2C%20gentle%20night%20light%20creating%20a%20cozy%20glow%2C%20a%20rocking%20chair%20with%20a%20soft%20blanket%2C%20dreamy%20and%20calm%20atmosphere%2C%20warm%20cream%20and%20soft%20beige%20tones%2C%20tranquil%20interior%20photography&width=800&height=500&seq=article-cover-sleep&orientation=landscape',
    readTime: 8,
    publishedAt: '2026-07-12',
    tags: ['宝宝睡眠', '睡眠训练', '科学育儿'],
  },
  {
    slug: 'san-shi-sui-hou-de-shen-cai-guan-li',
    title: '30 岁妈妈的体态重塑：不节食也能恢复产前身材的方法',
    excerpt: '产后身体变化让人沮丧，但恢复不是靠饿出来的。科学的力量训练 + 合理的营养搭配，让你比产前更健康、更有力量。',
    category: 'chan-hou-hui-fu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20mother%20doing%20gentle%20yoga%20in%20a%20bright%20airy%20living%20room%2C%20morning%20sunlight%20streaming%20in%2C%20comfortable%20athletic%20wear%2C%20houseplants%20around%2C%20calm%20and%20empowered%20atmosphere%2C%20warm%20natural%20tones%2C%20lifestyle%20fitness%20photography&width=800&height=500&seq=article-cover-fitness&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-10',
    tags: ['产后恢复', '体态管理', '健身'],
  },
  {
    slug: 'qin-zi-you-xi-0-1-sui',
    title: '0-1 岁亲子游戏大全：每月一个关键游戏促进宝宝发育',
    excerpt: '不需要昂贵的玩具，用生活中常见的物品就能和宝宝玩出花样。按月龄精选 12 个亲子游戏，在笑声中促进宝宝五大能力发展。',
    category: 'qin-zi-guan-xi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mother%20playing%20happily%20with%20her%20baby%20on%20a%20soft%20play%20mat%2C%20natural%20daylight%20from%20large%20windows%2C%20simple%20wooden%20toys%20scattered%20around%2C%20genuine%20laughter%20and%20connection%2C%20warm%20and%20joyful%20atmosphere%2C%20cream%20and%20soft%20blush%20tones%2C%20editorial%20family%20photography&width=800&height=500&seq=article-cover-play&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-07-08',
    tags: ['亲子游戏', '早教启蒙', '宝宝发育'],
  },
  {
    slug: 'ma-ma-shi-jian-guan-li-shu',
    title: '带娃妈妈的碎片时间管理术：每天多出 2 小时的秘密',
    excerpt: '当了妈妈之后，「没时间」成了口头禅。学会这套专为妈妈设计的时间管理方法，在带娃、家务和自我成长之间找到平衡。',
    category: 'zi-wo-ti-sheng',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20minimalist%20desk%20setup%20with%20a%20notebook%20and%20pen%2C%20a%20baby%20monitor%20nearby%2C%20morning%20coffee%20in%20a%20ceramic%20mug%2C%20sunlight%20creating%20warm%20patterns%2C%20organized%20and%20peaceful%20vibe%2C%20warm%20cream%20and%20terracotta%20accents%2C%20editorial%20workspace%20photography&width=800&height=500&seq=article-cover-timemgmt&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-07-05',
    tags: ['时间管理', '妈妈效率', '自我提升'],
  },
  {
    slug: 'nai-nai-bu-gou-zen-me-ban',
    title: '奶水不足怎么办？哺乳期追奶的正确方法与常见误区',
    excerpt: '「奶不够吃」是新妈妈最焦虑的问题之一。科学追奶不是靠喝汤，而是理解泌乳原理，掌握正确的哺乳姿势和频率。',
    category: 'ke-xue-yu-er',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mother%20breastfeeding%20her%20newborn%20in%20a%20comfortable%20nursing%20chair%20by%20a%20sunny%20window%2C%20soft%20natural%20lighting%2C%20cozy%20blanket%2C%20peaceful%20bonding%20moment%2C%20warm%20cream%20and%20blush%20tones%2C%20tender%20editorial%20motherhood%20photography&width=800&height=500&seq=article-cover-breastfeeding&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-07-02',
    tags: ['母乳喂养', '追奶方法', '哺乳技巧'],
  },
  {
    slug: 'chan-hou-pen-di-ji-kang-fu',
    title: '产后盆底肌康复指南：看不见的损伤，必须重视的修复',
    excerpt: '漏尿、腰酸、骨盆前倾……这些问题与盆底肌密切相关。了解盆底肌康复的科学方法，为自己的长期健康负责。',
    category: 'chan-hou-hui-fu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20doing%20gentle%20pelvic%20floor%20exercise%20on%20a%20yoga%20mat%20in%20a%20bright%20room%2C%20soft%20natural%20light%2C%20comfortable%20athletic%20clothing%2C%20calm%20and%20focused%20atmosphere%2C%20warm%20neutral%20tones%2C%20wellness%20lifestyle%20photography&width=800&height=500&seq=article-cover-pelvic&orientation=landscape',
    readTime: 8,
    publishedAt: '2026-06-28',
    tags: ['盆底肌康复', '产后修复', '女性健康'],
  },
  {
    slug: 'yu-er-jiao-lv-zheng-de-po-jie-fang-fa',
    title: '育儿焦虑症的破解方法：停止和「别人家的妈妈」比较',
    excerpt: '社交媒体上的完美妈妈让你焦虑吗？学会识别育儿焦虑的源头，建立属于自己的育儿标准，做最真实的妈妈。',
    category: 'xin-li-tiao-shi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20mother%20journaling%20at%20a%20cozy%20corner%20with%20warm%20natural%20lighting%2C%20a%20sleeping%20baby%20in%20a%20bassinet%20nearby%2C%20tea%20and%20notebook%2C%20peaceful%20self-reflection%20moment%2C%20soft%20warm%20tones%2C%20intimate%20lifestyle%20editorial%20photography&width=800&height=500&seq=article-cover-comparison&orientation=landscape',
    readTime: 7,
    publishedAt: '2026-06-25',
    tags: ['育儿焦虑', '心理健康', '自我接纳'],
  },
  {
    slug: 'you-er-yu-yan-bao-fa-qi',
    title: '抓住语言爆发期：1-2 岁宝宝语言启蒙的黄金法则',
    excerpt: '宝宝开口说话的时间差异很大，但科学的语言启蒙能让每个孩子的发展潜力得到最大释放。分享日常可操作的 8 个语言启蒙技巧。',
    category: 'ke-xue-yu-er',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mother%20reading%20a%20colorful%20picture%20book%20to%20her%20toddler%2C%20both%20sitting%20on%20a%20cozy%20rug%2C%20warm%20sunlight%20from%20a%20window%2C%20bookshelf%20with%20children%20books%20in%20background%2C%20joyful%20and%20educational%20moment%2C%20soft%20cream%20and%20pastel%20tones%2C%20editorial%20family%20photography&width=800&height=500&seq=article-cover-language&orientation=landscape',
    readTime: 6,
    publishedAt: '2026-06-22',
    tags: ['语言启蒙', '宝宝发育', '早教'],
  },
  {
    slug: 'quan-zhi-ma-ma-fu-chu-zhi-chang',
    title: '全职妈妈重返职场：从简历空白到自信面试的完整准备指南',
    excerpt: '脱离职场几年后想要重返，信心不足是最大的障碍。从简历优化到面试话术，帮你一步步找回职场竞争力。',
    category: 'zi-wo-ti-sheng',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20confident%20young%20woman%20in%20a%20bright%20modern%20office%20setting%2C%20professional%20yet%20warm%20atmosphere%2C%20soft%20natural%20light%2C%20laptop%20and%20notebook%20on%20desk%2C%20empowered%20and%20hopeful%20expression%2C%20warm%20neutral%20professional%20tones%2C%20editorial%20corporate%20portrait%20photography&width=800&height=500&seq=article-cover-career&orientation=landscape',
    readTime: 9,
    publishedAt: '2026-06-20',
    tags: ['重返职场', '职业规划', '自我提升'],
  },
];